export default {
  name: "MixinSimpleRowClick",
  data() {
    return {
      rowClickTimeout: null,
      rowMouseDown: null,
    };
  },
  beforeDestroy() {
    if (this.rowClickTimeout) {
      clearTimeout(this.rowClickTimeout);
      this.rowClickTimeout = null;
    }
  },
  methods: {
    onRowMouseDown(event) {
      this.rowMouseDown = {
        x: event.clientX,
        y: event.clientY,
      };
    },
    onRowClick(payload, event) {
      if (!event || event.defaultPrevented || event.button !== 0) {
        return;
      }

      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      if (this.isInteractiveTarget(event.target) || this.hasMouseDragged(event) || this.hasTextSelection()) {
        return;
      }

      if (this.rowClickTimeout) {
        clearTimeout(this.rowClickTimeout);
      }

      this.rowClickTimeout = setTimeout(() => {
        if (!this.hasTextSelection()) {
          this.handleSimpleRowClick(payload, event);
        }
        this.rowClickTimeout = null;
      }, 220);
    },
    onRowDoubleClick() {
      if (this.rowClickTimeout) {
        clearTimeout(this.rowClickTimeout);
        this.rowClickTimeout = null;
      }
    },
    isInteractiveTarget(target) {
      return Boolean(
        target
          && target.closest
          && target.closest("button, input, select, textarea, a, label, [role='button']"),
      );
    },
    hasMouseDragged(event) {
      if (!this.rowMouseDown || !event) {
        return false;
      }

      const distanceX = Math.abs(event.clientX - this.rowMouseDown.x);
      const distanceY = Math.abs(event.clientY - this.rowMouseDown.y);
      return distanceX > 4 || distanceY > 4;
    },
    hasTextSelection() {
      const selection = window.getSelection ? window.getSelection() : null;
      if (!selection) {
        return false;
      }

      return !selection.isCollapsed && String(selection).trim().length > 0;
    },
    handleSimpleRowClick(payload) {
      // À surcharger dans les composants qui utilisent ce mixin.
      return payload;
    },
  },
};
